import { api } from "./api";

function loadRazorpayScript() {
    return new Promise((resolve) => {
        if (window.Razorpay) return resolve(true);
        const s = document.createElement("script");
        s.src = "https://checkout.razorpay.com/v1/checkout.js";
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.body.appendChild(s);
    });
}

export async function payProgramFee(application, user) {
    const cfg = (await api.get("/payments/config")).data;
    if (!cfg.enabled) {
        return { ok: false, disabled: true, message: "Payments are not enabled yet. Your application is submitted — you can pay the program fee from My Applications once payments go live." };
    }
    const order = (await api.post("/payments/create-order", { application_id: application.id })).data;
    const loaded = await loadRazorpayScript();
    if (!loaded) return { ok: false, message: "Could not load payment gateway." };
    return new Promise((resolve) => {
        const rzp = new window.Razorpay({
            key: order.key_id,
            amount: order.amount,
            currency: order.currency,
            order_id: order.order_id,
            name: "TechBloom",
            description: `Program fee — ${application.internship_title}`,
            prefill: { name: user?.name || "", email: user?.email || "" },
            theme: { color: "#2D6A4F" },
            handler: async (resp) => {
                try {
                    await api.post("/payments/verify", {
                        application_id: application.id,
                        razorpay_order_id: resp.razorpay_order_id,
                        razorpay_payment_id: resp.razorpay_payment_id,
                        razorpay_signature: resp.razorpay_signature,
                    });
                    resolve({ ok: true });
                } catch (e) {
                    resolve({ ok: false, message: "Payment verification failed. Contact support." });
                }
            },
            modal: { ondismiss: () => resolve({ ok: false, message: "Payment cancelled." }) },
        });
        rzp.open();
    });
}
